import { debounce, formatMoney, startViewTransition } from '@theme/utilities';


// class remove on touchmove


const element = document.querySelector('html');
const reviewContainer = document.querySelector('.google-review-append');
let widgetAdded = false, chatyScriptAdded = false, kalviyo = false, mouseFlow = false;

function throttle(callback, limit) {
  let lastCall = 0;
  return function () {
    const now = Date.now();
    if (now - lastCall >= limit) {
      lastCall = now;
      callback.apply(this, arguments);
    }
  };
}

function loadImage(imgElement) {
  imgElement.src = imgElement.getAttribute('data-src');
  imgElement.classList.remove('shiny-placeholder-image');
}

const observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      loadImage(entry.target);
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.1 });

document.querySelectorAll('.shiny-placeholder-image').forEach(image => observer.observe(image));

function loadScripts() {
  if (!widgetAdded || !kalviyo || !chatyScriptAdded) {
    const scripts = [
      {
        src: 'https://cdn.grw.reputon.com/assets/widget.js?shop=n3zbnn-bj.myshopify.com',
        condition: !widgetAdded,
        onLoad: () => { widgetAdded = true; if (reviewContainer) reviewContainer.innerHTML = `<div class="reputon-google-reviews-widget" data-type="carousel" data-content-index="1" data-theme="light" data-autoscroll="true" data-review-photos-type="small" data-write-review="true" data-show-rating="true" data-fixed-reviews-height="false"></div>`; }
      },
      {
        src: 'https://static.klaviyo.com/onsite/js/Y4t27k/klaviyo.js?company_id=Y4t27k',
        condition: !kalviyo,
        onLoad: () => { kalviyo = true; }
      },
      {
        src: 'https://cdn.chaty.app/pixel.js?id=77Q7r2FL&shop=n3zbnn-bj.myshopify.com',
        condition: !chatyScriptAdded,
        onLoad: () => { chatyScriptAdded = true; }
      }
    ];

    scripts.forEach(scriptData => {
      if (scriptData.condition && !document.querySelector(`script[src="${scriptData.src}"]`)) {
        const scriptTag = document.createElement('script');
        scriptTag.src = scriptData.src;
        scriptTag.defer = true;
        scriptTag.onload = scriptData.onLoad;
        document.body.appendChild(scriptTag);
      }
    });
  }
}

function removeClassOnScrollTouchMoveOrMouseMove() {
  element.classList.remove('hide-items');
  loadScripts();

  document.querySelectorAll('.shiny-placeholder-image').forEach(image => {
    if (!image.src) loadImage(image);
  });

  if (!mouseFlow) {
    window._mfq = window._mfq || [];
    const mf = document.createElement('script');
    mf.type = 'text/javascript';
    mf.defer = true;
    mf.src = '//cdn.mouseflow.com/projects/fd473092-1a2a-4737-a60f-d2bc9953c901.js';
    document.getElementsByTagName('head')[0].appendChild(mf);
    mouseFlow = true;
  }
}

document.addEventListener('touchmove', throttle(removeClassOnScrollTouchMoveOrMouseMove, 300), { passive: true });
document.addEventListener('scroll', throttle(removeClassOnScrollTouchMoveOrMouseMove, 300));
document.addEventListener('mousemove', throttle(removeClassOnScrollTouchMoveOrMouseMove, 300));


// mobile menu toggle JS start

document.addEventListener("DOMContentLoaded", function () {
  const submenuLinks = document.querySelectorAll('.has-submenu');

  submenuLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const parentItem = this.closest('.menu__item');
      document.querySelectorAll('.menu__item.active_submenu').forEach(item => {
        if (item !== parentItem) {
          item.classList.remove('active_submenu');
        }
      });
      parentItem.classList.toggle('active_submenu');
    });
  });
  const grandToggleLinks = document.querySelectorAll('.sub-toggle');

  grandToggleLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const parentLink = this.closest('.menu-link');
      const siblings = parentLink.parentElement.querySelectorAll('.menu-link.active_grand');
      siblings.forEach(sib => {
        if (sib !== parentLink) {
          sib.classList.remove('active_grand');
        }
      });
      parentLink.classList.toggle('active_grand');
    });
  });
});

// mobile menu toggle JS End

// Mobile Menu Drawer Toggle JS Start

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener('click', function(event){
    if (!event.target.closest('.mobile_menu_bar')) return;

    const navDrawer = document.querySelector('nav-drawer');
    if (navDrawer) {
      navDrawer.classList.add('show_mobile_menu');
      document.documentElement.setAttribute('scroll-lock', '');
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const closeIcon = document.querySelector('.mobile_menu_drawer .drawer_close');
  const navDrawer = document.querySelector('nav-drawer');

  if (closeIcon && navDrawer) {
    closeIcon.addEventListener('click', function(){
      navDrawer.classList.remove('show_mobile_menu');
      document.documentElement.removeAttribute('scroll-lock');
    });
  }
});

// Mobile Menu Drawer Toggle JS End

// newsletter shaker js start

document.addEventListener("DOMContentLoaded", function () {
  var shakeNewsletter = document.querySelector('.Wrap_newsletter .email-signup__button');
  var emailInput = document.querySelector('.Wrap_newsletter .email-signup__input');
  var shakeElement = document.querySelector('.Wrap_newsletter .email-signup__form');
  
  if(shakeNewsletter && emailInput) {
    shakeNewsletter.addEventListener('click', function() {
      var checkInput = emailInput.value;
      
      if(checkInput == '') {
        shakeElement.classList.add('shake');
        
        setTimeout(function() {
          shakeElement.classList.remove('shake');
        }, 500);
      }
    });
  }
});

// newsletter shaker js End

// Tabs js start

document.addEventListener('DOMContentLoaded', () => {
  const tabGroups = document.querySelectorAll('.tabs_block');

  tabGroups.forEach(group => {
    const headings = group.querySelectorAll('.tabs_heading[data-heading]');
    const panes = group.querySelectorAll('.tabs_content[data-content]');

    headings.forEach(head => {
      head.addEventListener('click', () => {
        headings.forEach(h => h.classList.remove('active'));
        panes.forEach(p => p.classList.remove('active'));

        head.classList.add('active');
        const id = head.dataset.heading;

        const targetPane = group.querySelector(`.tabs_content[data-content="${id}"]`);
        if (targetPane) {
          targetPane.classList.add('active');
        }
      });
    });
  });
});

// Tabs js End

// size popup trigger

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.product-information__media slideshow-component')) {
    var getHeight = document.querySelector('.product-information__media slideshow-component').offsetHeight;
    document.querySelector('.product-information').style.setProperty('--slideshow-height', getHeight + 'px');
  }
  var checkSize = document.querySelector('.size_text');
  if(checkSize){
    checkSize.addEventListener('click',function(){
      document.querySelector('.popup-link .size-guide').click();
    });
  }

  // Price Range slider Js
  if (document.querySelector('facets-form-component')) {
    function removeDesktopOnMobile() {
      if (window.innerWidth <= 767) {
        const desktop = document.querySelector('#main_desktop');
        if (desktop) desktop.remove();
      }
    }

    const PRICE_MIN_GAP = 10;

    function debounce(func, delay = 300) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), delay);
      };
    }

    function getPriceSliderContext(rangeInput) {
      const priceRange = rangeInput.closest('price-range.facets__price');
      if (!priceRange) return null;

      const minRange = priceRange.querySelector('.field__input-price.min');
      const maxRange = priceRange.querySelector('.field__input-price.max');
      const minVal = priceRange.querySelector('.minimimum-filter__price');
      const maxVal = priceRange.querySelector('.maximum-filter__price');
      const panel = priceRange.closest('floating-panel-component, details, form') || priceRange.parentElement;
      const priceFacet = panel?.querySelector('price-facet-component');
      const minInput = priceFacet?.querySelector('[ref="minInput"]');
      const maxInput = priceFacet?.querySelector('[ref="maxInput"]');

      if (!(minRange instanceof HTMLInputElement) || !(maxRange instanceof HTMLInputElement)) return null;

      return { priceRange, minRange, maxRange, minVal, maxVal, priceFacet, minInput, maxInput };
    }

    function syncFacetInputs(ctx, minValue, maxValue) {
      const rangeMax = parseInt(ctx.maxRange.max, 10);
      if (ctx.minInput instanceof HTMLInputElement) {
        ctx.minInput.value = minValue > 0 ? String(minValue) : '';
      }
      if (ctx.maxInput instanceof HTMLInputElement) {
        ctx.maxInput.value = maxValue < rangeMax ? String(maxValue) : '';
      }
    }

    function updatePriceSlider(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || !target.classList.contains('field__input-price')) return;

      const ctx = getPriceSliderContext(target);
      if (!ctx) return;

      let minValue = parseInt(ctx.minRange.value, 10);
      let maxValue = parseInt(ctx.maxRange.value, 10);
      const currencySymbol = document.querySelector('body')?.dataset?.currency || '$';

      if (maxValue - minValue < PRICE_MIN_GAP) {
        if (target === ctx.minRange) {
          minValue = maxValue - PRICE_MIN_GAP;
          ctx.minRange.value = String(minValue);
        } else {
          maxValue = minValue + PRICE_MIN_GAP;
          ctx.maxRange.value = String(maxValue);
        }
      }

      if (ctx.minVal) ctx.minVal.textContent = `${currencySymbol}${ctx.minRange.value}`;
      if (ctx.maxVal) ctx.maxVal.textContent = `${currencySymbol}${ctx.maxRange.value}`;

      syncFacetInputs(ctx, parseInt(ctx.minRange.value, 10), parseInt(ctx.maxRange.value, 10));
    }

    function triggerPriceUpdate(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || !target.classList.contains('field__input-price')) return;
      if (!document.contains(target)) return;

      const ctx = getPriceSliderContext(target);
      if (!ctx || !document.contains(ctx.priceFacet)) return;

      const minValue = parseInt(ctx.minRange.value, 10);
      const maxValue = parseInt(ctx.maxRange.value, 10);
      if (Number.isNaN(minValue) || Number.isNaN(maxValue) || maxValue <= minValue) return;

      syncFacetInputs(ctx, minValue, maxValue);

      // Skip no-op updates (full range = no price filter)
      const nextKey = `${minValue}-${maxValue}`;
      if (ctx.priceRange.dataset.lastPriceKey === nextKey) return;
      ctx.priceRange.dataset.lastPriceKey = nextKey;

      ctx.priceFacet.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const debouncedTrigger = debounce(triggerPriceUpdate, 450);

    function onPricePointerEnd(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || !target.classList.contains('field__input-price')) return;
      if (!document.contains(target)) return;
      // Mobile browsers often skip the change event on range inputs
      updatePriceSlider(event);
      triggerPriceUpdate(event);
    }

    document.addEventListener('input', (event) => {
      updatePriceSlider(event);
      // Live-apply while dragging so mobile still filters even without change/touchend
      debouncedTrigger(event);
    });
    document.addEventListener('change', (event) => {
      if (!(event.target instanceof HTMLInputElement) || !event.target.classList.contains('field__input-price')) {
        return;
      }
      updatePriceSlider(event);
      triggerPriceUpdate(event);
    });
    document.addEventListener('touchend', onPricePointerEnd, { passive: true });
    document.addEventListener('pointerup', onPricePointerEnd);

    window.updatePrice = function () {
      document.querySelectorAll('price-range.facets__price .field__input-price.max').forEach((maxRange) => {
        if (maxRange instanceof HTMLInputElement) {
          updatePriceSlider({ target: maxRange });
        }
      });
    };

    window.updatePrice();
    setInterval(removeDesktopOnMobile, 1000);
  }

  // Price range slider end

});
document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll("video");

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target;
        const sources = video.querySelectorAll("source[data-src]");

        sources.forEach(source => {
          source.src = source.dataset.src;
          source.removeAttribute("data-src");
        });

        video.load();

        // Try autoplay if muted
        if (video.muted) {
          video.play().catch(() => {
            // Do nothing, no controls
          });
        }

        obs.unobserve(video);
      }
    });
  });

  videos.forEach(video => observer.observe(video));
});


// chat icon js start

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const interval = setInterval(() => {
      const element = document.querySelector('#shopify-chat inbox-online-store-chat');
      if (element && element.shadowRoot) {

        const root = element.shadowRoot;

        const qs = (sel) => root.querySelector(sel);

        if (root) {
          let style = document.createElement('style');
          style.textContent = `
            /* Ensure these styles are applied inside the shadow DOM */
            :host {
              display: block;
            }
            
            button.chat-toggle {
              width: 40px !important;
              height: 40px !important;
              border: 3px solid #fff;
            }

            button.chat-toggle svg {
              width: 30px !important;
              height: 30px !important;
            }

            .chat-notification {
              width: 18px !important;
              height: 18px !important;
              line-height: 18px !important;
            }
             @media (max-width: 450px) {
              button.chat-toggle {
                width: 25px !important;
                height: 25px !important;
                border: 3px solid #fff;
              }
              button.chat-toggle svg {
                width: 20px !important;
                height: 20px !important;
              }
            }
          `;
          root.appendChild(style);

          clearInterval(interval);
        }
      }
    }, 200);
  }, 1000); 
});

(function() {
    if (document.body.classList.contains('itg_store-locator')) {
        function processSocialLinks() {
            var allSocialLinks = document.querySelectorAll('.social-link');

            allSocialLinks.forEach(function(links) {
                if (!links.classList.contains('social-loaded')) {
                    var getHref = links.querySelector('a') ? links.querySelector('a').getAttribute('href') : '';
                    
                    if (getHref) {
                        var socialLinks = getHref.split(','); 

                        var newDiv = document.createElement('div');
                        newDiv.classList.add('social-links-container'); 

                        socialLinks.forEach(function(link) {
                            var anchorTag = document.createElement('a');
                            anchorTag.setAttribute('href', link.trim());
                            anchorTag.setAttribute('target', '_blank');
                            var linkText = link.trim();

                            if (linkText.includes('facebook')) {
                                anchorTag.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0949/6975/8028/files/facebook_4628653.png?v=1758821127">';
                            } 
                            if (linkText.includes('twitter') || linkText.includes('https://x.com')) {
                                anchorTag.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0949/6975/8028/files/twitter_4628695.png?v=1758821500">';
                            }
                            if (linkText.includes('instagram')) {
                                anchorTag.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0949/6975/8028/files/instagram_4628656.png?v=1758821302">';
                            } 
                            if (linkText.includes('linkedin')) {
                                anchorTag.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0949/6975/8028/files/linkedin_4628658.png?v=1758821189">';
                            } 
                            if (linkText.includes('tiktok')) {
                                anchorTag.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0949/6975/8028/files/music_14459372.png?v=1759167606">';
                            } 
                            if (linkText.includes('https://wa.me')) {
                                anchorTag.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0949/6975/8028/files/chat-bubble_5441403.png?v=1759167930">';
                            }
                            if (linkText.includes('youtube')) {
                                anchorTag.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0949/6975/8028/files/youtube_4628711.png?v=1758821436">';
                            }
                            if (linkText.includes('pinterest')) {
                                anchorTag.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0949/6975/8028/files/svgviewer-png-output_8.png?v=1758815253">`;
                            }
                            newDiv.appendChild(anchorTag);
                        });

                        links.appendChild(newDiv);
                        links.classList.add('social-loaded');
                    }
                }
            });
        }

        // Create a MutationObserver to monitor changes in the document
        var observer = new MutationObserver(function(mutationsList, observer) {
            for (var mutation of mutationsList) {
                if (mutation.type === 'childList' || mutation.type === 'attributes') {
                    if (mutation.target.classList.contains('social-link') || mutation.type === 'childList') {
                        // Re-run processSocialLinks if the social link is added or changed
                        processSocialLinks();
                    }
                }
            }
        });

        // Start observing for changes in the body (or a more specific container if needed)
        observer.observe(document.body, {
            childList: true,      // Watch for added or removed elements
            subtree: true,        // Watch all descendant nodes
            attributes: true,     // Watch for attribute changes
            attributeFilter: ['href'] // Specifically watch the `href` attributes of the links
        });

    }

    var sizeGuide = document.querySelector('.size-guide-tab');
    if (sizeGuide) {
        sizeGuide.addEventListener('click', function() {
            var sizeGuideElements = document.querySelectorAll('[data-heading="size-guide"]');
            
            if (sizeGuideElements.length > 0) {
                sizeGuideElements.forEach(function(sizeGuideElement) {
                    console.log(sizeGuideElement);
                    sizeGuideElement.click();
                    sizeGuideElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
            } else {
                console.error('Size guide elements not found');
            }
        });
    }
})();



(function () {
  'use strict';

  function hydrateVideo(video) {
    if (!video) return;

    // force copy all <source data-src> to src
    video.querySelectorAll('source[data-sourcesrc]').forEach(source => {
      const newSrc = source.dataset.sourcesrc;
      if (newSrc && source.getAttribute('src') !== newSrc) {
        source.setAttribute('src', newSrc);
      }
    });

    // reload the video after swapping sources
    try { video.load(); } catch (e) {}

    // autoplay if flagged — don't remute if user already unmuted via sound button
    if (
      video.hasAttribute('autoplay') ||
      video.hasAttribute('data-video-autoplay') ||
      video.dataset.videoAutoplay === 'true'
    ) {
      if (video.dataset.userUnmuted !== '1') {
        video.muted = true;
      }
      video.playsInline = true;
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    }

    // mark as hydrated for later, but don’t skip if already had data-hydrated
    video.dataset.hydrated = '1';
  }

  function primeExisting() {
    document.querySelectorAll('video[data-video-type="native"]').forEach(hydrateVideo);
  }

  // mutation observer to hydrate new videos added later
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches && node.matches('video[data-video-type="native"]')) {
            hydrateVideo(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('video[data-video-type="native"]').forEach(hydrateVideo);
          }
        });
      }
    });
  });

  function startAll() {
    primeExisting();
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }


    if (document.querySelector('source[data-sourcesrc]')) {
        // trigger once on first mouse move or touch
        window.addEventListener('mousemove', startAll, { once: true, passive: true });
        window.addEventListener('touchstart', startAll, { once: true, passive: true });
    }
})();



document.addEventListener("scroll", function () {
    document.body.classList.remove("is_loaded_sections");
});
